import { IOption } from 'components/input/selectInput';

export const ImagerTableColumns: {
  accessor: string;
  Header: string;
  className?: string;
  editOptions?: { inputType: React.HTMLInputTypeAttribute; options?: IOption[] };
}[] = [
  {
    accessor: 'robotId',
    Header: 'Robot Id',
    className: 'puckCount',
  },
  {
    accessor: 'name',
    Header: 'Robot Name',
  },
];

export const GroupQuotaTableColumns: {
  accessor: string;
  Header: string;
  className?: string;
  editOptions?: { inputType: React.HTMLInputTypeAttribute; options?: IOption[] };
}[] = [
  {
    accessor: 'groupName',
    Header: 'Group Name',
  },
  {
    accessor: 'plateQuota',
    Header: 'Total Plate Quota',
    className: 'puckCount',
    editOptions: { inputType: 'text' },
  },
];
